jQuery(document).ready( function($) {

    $('.c-hamburger').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('nav-panels--open');

        if ($('.c-hamburger').css('display') !== 'none') { //hamburger is visible
            $('.nav-panel').css('transition', 'transform .5s');
        } else {
            $('.nav-panel').css('transition', 'none');
        }
    });

    $('.banner .scrolldown').on('click', function(e) {
        e.preventDefault();
        setTimeout(function () {
            let y = parseInt($('.banner').css('height'));
            $('html,body').animate({scrollTop: y}, 600);
        }, 100);
    });


    function stickynav() {
        let scrolltop = $(window).scrollTop(); //current vertical position from the top
        if (scrolltop > 50) {
            $('body').addClass('sticky');
        } else {
            $('body').removeClass('sticky');
        }
    }
    stickynav();

    $(window).scroll(function() {
        stickynav();
    });


    function doresize() {
        $('body').removeClass('nav-panels--open');
        if ($('.c-hamburger').css('display') !== 'none') { //hamburger is visible
            $('.nav-panel').css('transition', 'transform .5s');
        } else {
            $('.nav-panel').css('transition', 'none');
        }
    }

    doresize();
    window.onresize = doresize;

});
